
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class ApprovalInReturnBOMGrid extends Serenity.EntityGrid<ApprovalInReturnBOMRow, any> {
        protected getColumnsKey() { return 'PurchaseReturn.ApprovalInReturnBOM'; }
        protected getDialogType() { return ApprovalInReturnBOMDialog; }
        protected getIdProperty() { return ApprovalInReturnBOMRow.idProperty; }
        protected getInsertPermission() { return ApprovalInReturnBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInReturnBOMRow.localTextPrefix; }
        protected getService() { return ApprovalInReturnBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}